import { reducerInit } from "../../api/dbselect.js"

const init = reducerInit("orderline")

export const orderLineReducer = (state = init, action) => {
	switch (action.type) {
		case "INSERT_ORDERLINE":
			return [...state, action.response[0]]

		case "UPDATE_ORDERLINE":
			return state.map((object, i) => {
				let newObject = JSON.parse(JSON.stringify(object))
				if (newObject.orderlineid === action.id) {
					for (const data in action.json) {
						newObject[data] = action.json[data]
					}
					return newObject
				} else {
					return newObject
				}
			})

		case "DELETE_ORDERLINE":
			return state.filter((object) => object.orderlineid !== action.id)

		default:
			return state
	}
}
